<script lang="ts">
	import Accordion, { Content, Header, Panel } from '@smui-extra/accordion';
	import Card from '@smui/card';
	import { writable } from 'svelte/store';
	import Title from '../../../../../shared/components/common/Title.svelte';
	import BoxWithImage from '../../../common/BoxWithImage/BoxWithImage.svelte';
	import NewBoxWithImage from '../../../common/BoxWithImage/NewBoxWithImage.svelte';

	function createBoxStore() {
		return writable([]);
	}

	export let reteStradaleBoxes = createBoxStore();
	export let ciclabilitaBoxes = createBoxStore();
	export let trasportoPubblicoBoxes = createBoxStore();
	export let mobilitaCondivisaBoxes = createBoxStore();


	export let maxReteStradaleBoxesReached = writable(false);
	export let maxCiclabilitaBoxesReached = writable(false);
	export let maxTrasportoPubblicoBoxesReached = writable(false);
	export let maxMobilitaCondivisaBoxesReached = writable(false);

	function addBox(boxStore, tempBox, maxBoxesReached) {
		boxStore.update(b => {
			if (b.length < 5) {
				maxBoxesReached.set(false);
				return [...b, { id: Date.now(), ...tempBox }];
			} else {
				maxBoxesReached.set(true);
				return b;
			}
		});
	}

	function handleTextChange(event, boxStore) {
		const { id, text } = event.detail;
		boxStore.update(b => b.map(box => box.id === id ? { ...box, text } : box));
	}

	function handleImageChange(event, boxStore) {
		const { id, image, file } = event.detail;
		boxStore.update(b => b.map(box => {
			if (box.id === id) {
				return { ...box, image, file };
			} else {
				return box;
			}
		}));
	}

	function removeBox(event, boxStore, maxBoxesReached) {
		const { id } = event.detail;
		boxStore.update(b => {
			const updatedBoxes = b.filter(box => box.id !== id);
			if (updatedBoxes.length < 5) {
				maxBoxesReached.set(false);
			}
			return updatedBoxes;
		});
	}
</script>

	<Card class="md:px-8 md:py-8 pt-4" padded>
		<div class="flex justify-between">
			<Title title="Paragrafi accessibilità PSCL" inCard={true} />
		</div>
		<div class="accordion-container pt-4">
		<Accordion>
			<!-- Rete stradale Panel -->
			<Panel>
				<Header>Rete stradale</Header>
				<Content>
					{#each $reteStradaleBoxes as box (box.id)}
						<BoxWithImage
						id={box.id}
						uniqueId={`rete-stradale-${box.id}`}
						paragrafoId={box.paragrafoId}
						text={box.text}
						image={box.image}
						allegato={box.allegato}
						file={box.file}
						on:textChange={(e) => handleTextChange(e, reteStradaleBoxes)}
						on:imageChange={(e) => handleImageChange(e, reteStradaleBoxes)}
						on:remove={(e) => removeBox(e, reteStradaleBoxes, maxReteStradaleBoxesReached)}
						boxStore={reteStradaleBoxes}
						/>
					{/each}
					<NewBoxWithImage 
						id="rete-stradale" 
						on:addBox={(e) => addBox(reteStradaleBoxes, e.detail, maxReteStradaleBoxesReached)} 
						disableAdd={$maxReteStradaleBoxesReached} 
					/>
				</Content>
			</Panel>

			<!-- Ciclabilità Panel -->
			<Panel>
				<Header>Ciclabilità</Header>
				<Content>
					{#each $ciclabilitaBoxes as box (box.id)}
						<BoxWithImage
							id={box.id}
							uniqueId={`ciclabilita-${box.id}`}
							paragrafoId={box.paragrafoId}
							text={box.text}
							image={box.image}
							allegato={box.allegato}
							file={box.file}
							on:textChange={(e) => handleTextChange(e, ciclabilitaBoxes)}
							on:imageChange={(e) => handleImageChange(e, ciclabilitaBoxes)}
							on:remove={(e) => removeBox(e, ciclabilitaBoxes, maxCiclabilitaBoxesReached)}
							boxStore={ciclabilitaBoxes}
						/>
					{/each}
					<NewBoxWithImage
						id="ciclabilita" 
						on:addBox={(e) => addBox(ciclabilitaBoxes, e.detail, maxCiclabilitaBoxesReached)} 
						disableAdd={$maxCiclabilitaBoxesReached} 
					/>
				</Content>
			</Panel>

			<!-- Trasporto pubblico Panel -->
			<Panel>
				<Header>Trasporto pubblico</Header>
				<Content>
					{#each $trasportoPubblicoBoxes as box (box.id)}
						<BoxWithImage
							id={box.id}
							paragrafoId={box.paragrafoId}
							uniqueId={`trasporto-pubblico-${box.id}`}
							text={box.text}
							image={box.image}
							allegato={box.allegato}
							file={box.file}
							on:textChange={(e) => handleTextChange(e, trasportoPubblicoBoxes)}
							on:imageChange={(e) => handleImageChange(e, trasportoPubblicoBoxes)}
							on:remove={(e) => removeBox(e, trasportoPubblicoBoxes, maxTrasportoPubblicoBoxesReached)}
							boxStore={trasportoPubblicoBoxes}
						/>
					{/each}
					<NewBoxWithImage
						id="trasporto-pubblico" 
						on:addBox={(e) => addBox(trasportoPubblicoBoxes, e.detail, maxTrasportoPubblicoBoxesReached)} 
						disableAdd={$maxTrasportoPubblicoBoxesReached} 
					/>
				</Content>
			</Panel>

			<!-- Mobilità condivisa Panel -->
			<Panel>
				<Header>Mobilità condivisa</Header>
				<Content>
					{#each $mobilitaCondivisaBoxes as box (box.id)}
						<BoxWithImage
							id={box.id}
							uniqueId={`mobilita-condivisa-${box.id}`}
							paragrafoId={box.paragrafoId}
							text={box.text}
							image={box.image}
							allegato={box.allegato}
							file={box.file}
							on:textChange={(e) => handleTextChange(e, mobilitaCondivisaBoxes)}
							on:imageChange={(e) => handleImageChange(e, mobilitaCondivisaBoxes)}
							on:remove={(e) => removeBox(e, mobilitaCondivisaBoxes, maxMobilitaCondivisaBoxesReached)}
							boxStore={mobilitaCondivisaBoxes}
						/>
					{/each}
					<NewBoxWithImage 
						id="mobilita-condivisa" 
						on:addBox={(e) => addBox(mobilitaCondivisaBoxes, e.detail, maxMobilitaCondivisaBoxesReached)} 
						disableAdd={$maxMobilitaCondivisaBoxesReached} 
					/>
				</Content>
			</Panel>
		</Accordion>
  	</div>
</Card>
